module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "assets/unzip_imgs.worker.0f71c695fc76d9b7d6b8.js");
}
